import { render, staticRenderFns } from "./FilterableTablePaging.vue?vue&type=template&id=794b378e&"
import script from "./FilterableTablePaging.vue?vue&type=script&lang=js&"
export * from "./FilterableTablePaging.vue?vue&type=script&lang=js&"
import style0 from "./FilterableTablePaging.vue?vue&type=style&index=0&id=794b378e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports